import React from 'react';
import { AtSignIcon, FacebookIcon, MailIcon } from 'lucide-react';
const links = [{
  icon: AtSignIcon,
  label: 'Instagram: @Tuconexioneducativa',
  href: 'https://instagram.com/tuconexioneducativa'
}];
export function Footer() {
  return <footer className="bg-brown pb-28 text-cream lg:pb-14" style={{
    paddingBottom: "32px"
  }} data-id="element-87" data-mp="32pfgeet4hnzr">
      <div className="mx-auto max-w-content px-6 pt-14" data-id="element-88" data-mp="36pzaf9iegbho">
        <p className="mx-auto max-w-lg text-center font-display text-2xl italic leading-snug text-cream" data-id="element-89" data-mp="3ueiknul0eyce">
          “Fuerza y honor son su vestidura; y se ríe de lo por venir.”
        </p>
        <p className="mt-2 text-center font-sans text-sm text-gold-soft" data-id="element-90" data-mp="3lem127dh8po7">Proverbios 31:25</p>

        <div className="mt-10 flex flex-col items-center gap-6 border-t border-cream/15 pt-8 md:flex-row md:justify-between" style={{
        paddingTop: "0px"
      }} data-id="element-91" data-mp="3qdf393nbcu92">
          <ul className="flex flex-col items-center gap-3 font-sans text-sm md:flex-row md:gap-8" data-id="element-92" data-mp="29xvrce9uhfpu">
            {links.map(link => <li key={link.label} data-id="element-93" data-mp="2evxaez79tf1b">
                
              </li>)}
          </ul>

          <p className="text-center font-sans text-xs leading-relaxed text-cream/60 md:text-right" data-id="element-94" data-mp="3lbmtfq7jj4eu">
            © Desafío Mujer de Proverbios 31 2026 — Todos los derechos reservados.
            <br data-id="element-95" data-mp="3v9axx7uy7qa7" />
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
        </div>
      </div>
    </footer>;
}